module.exports = __webpack_public_path__ + "img/singup8.542c4868.jpg";